import type { RfxListTab } from "../../types/rfx-list.type";

/**
 * `approvals` only offers these two tabs (`App\Enums\RfxListScope::tabs()` —
 * pinned in rfx-tab-config.test.ts / task-007.review.md). A drift here is a
 * silent-empty-tab bug — fail loud instead.
 */
export const APPROVALS_TABS: readonly RfxListTab[] = [
	"current",
	"past",
] as const;

export const assertKnownApprovalsTab = (tab: RfxListTab): void => {
	if (!(APPROVALS_TABS as readonly string[]).includes(tab)) {
		throw new Error(
			`Unrecognised approvals tab key "${tab}" — FE/BE tab-map drift.`
		);
	}
};

export const getApprovalsEmptyStateCopy = (tab: RfxListTab): string => {
	switch (tab) {
		case "current":
			return "No pending approvals.";
		case "past":
			return "No past approval activity.";
		default:
			throw new Error(
				`Unrecognised approvals tab key "${tab}" — FE/BE tab-map drift.`
			);
	}
};
